import { Slider, SxProps, Theme, useTheme } from '@mui/material';
import { FC } from 'react';
import { Star } from '@mui/icons-material';
import styled from 'styled-components';

interface Props {
  disabled?: boolean;
  value: number | number[];
  onChange: (event: Event, newValue: number | number[]) => void;
  sx?: SxProps<Theme>;
}

const SliderContainer = styled.div`
  display: flex;
  justify-content: center;
`;

function valuetext(value: number) {
  return value === 1 ? `${value} Star` : `${value} Stars`;
}

const marks = [
  {
    value: 1,
    label: <Star sx={{ fontSize: 16 }} />,
  },
  {
    value: 2,
    label: <Star sx={{ fontSize: 16 }} />,
  },
  {
    value: 3,
    label: <Star sx={{ fontSize: 16 }} />,
  },
  {
    value: 4,
    label: <Star sx={{ fontSize: 16 }} />,
  },
  {
    value: 5,
    label: <Star sx={{ fontSize: 16 }} />,
  },
];

const SliderStarsAsLabels: FC<Props> = ({ disabled, value, onChange, sx }) => {
  const theme = useTheme();

  return (
    <SliderContainer>
      <Slider
        disabled={disabled}
        getAriaLabel={() => 'Star range'}
        value={value}
        onChange={onChange}
        valueLabelDisplay="auto"
        getAriaValueText={valuetext}
        min={1}
        max={5}
        marks={marks}
        size="medium"
        sx={{
          ...sx,
          mx: theme.spacing(1),
          '& .MuiSlider-markLabelActive': {
            color: disabled ? theme.palette.text.disabled : theme.palette.secondary.main,
          },
        }}
      />
    </SliderContainer>
  );
};

export default SliderStarsAsLabels;
